import socketIOClient from "socket.io-client";
import config from '~/Classes/siteVars.js';
import axios from "~/data/http/axios";
import * as userActions from '~/data/actions/userActions'; //now we can use user actions here
import thestore from '~/data/store/store';

export class UiSocket {

    constructor() {
        this.uiSocket = undefined;
    }

    async init(callback) {
        const account = JSON.parse(localStorage.getItem("reduxPersist:accountMaster"));
        const user = JSON.parse(localStorage.getItem("reduxPersist:user"));
        if (!account?.id) return;
        if (!user?.userID) return;
        if (!user?.loggedIn) return;

        const accountMasterId = account.id;
        const accountUserId = user.userID;

        let authToken = await axios.post(`/accountmaster/socketauth`)
        if (!authToken) return;
        authToken = authToken.data;
        this.uiSocket = socketIOClient(
            config.uiSocketServer + "/dynamic_" + accountMasterId, {
            transports: ['websocket'],
            "path": "/uisocket",
            "query": {
                token: authToken
            },
            "forceNew": true
        }
        );

        return this.listeners(callback);
    }

    listeners(newEvent = () => { }) {
        this.uiSocket.on("connect", (data) => {
            this.uiSocket.emit("pageChange", {
                pathname: window.location.pathname + window.location.search
            })
            newEvent({
                event: "connected",
                data
            })
        });

        this.uiSocket.on("recieveBrowserNotification", async (data) => {

            //log if notifications are enabled
            if (Notification.permission !== "granted") {
                return;
            }
            let notification = new Notification(data.title, {
                body: data.message,
                icon: "https://cdn1.ourmailserv.com/siteContent/transpondLogos/Logomark_Purple.png"
            });
            notification.onclick = function (event) {
                event.preventDefault();
                window.open(data.link, '_blank');
            };

            newEvent({
                event: "recieveBrowserNotification",
                data
            })
        });
        this.uiSocket.on("userPageChange", async (data) => {
            data = data.filter(x => x.id != this.uiSocket.id);


            let otherUsersHere = [];

            try
            {
                const warningPageRules = [
                    {pathname: /^\/cp\/campaigns\/add\/standard\/[^/]+$/},
                    {pathname: /^\/cp\/templates\/add\/dragDrop\/[^/]+$/},
                    {pathname: /^\/cp\/templates\/add\/dragDropv2\/[^/]+$/},
                    {pathname: /^\/cp\/templates\/add\/wysiwyg\/[^/]+$/},
                    {pathname: /^\/cp\/templates\/add\/fromCode\/[^/]+$/},
                    {pathname: /^\/cp\/automation\/addnew\/[^/]+$/},
                    {pathname: /^\/cp\/campaigns\/add\/ab\/[^/]+$/},
                    {pathname: /^\/cp\/campaigns\/add\/social\/[^/]+$/},
                    {
                    pathname: "/cp/templates/add/dragdrop",
                    query: {
                        form: "true",
                        groupId: "mpexists", //just has to exist
                        formId: "mpexists" //just has to exist
                    }
                    }
                ];

                function checkIfOnUrl(ourUrl) {
                    return warningPageRules.find(rule => {
                        if (rule.pathname instanceof RegExp) {
                        if (!rule.pathname.test(ourUrl.pathname)) return false;
                        }
                        if (rule.query) {
                        return Object.entries(rule.query).every(([key, val]) => {
                            if (!ourUrl.searchParams.has(key)) return false;
                            if (val === "mpexists") return true;
                            return ourUrl.searchParams.get(key) === val;
                        });
                        }
                        return true;
                    });
                }
                
                function checkIfOthersMatchOurUrl(matchedUrlRule, ourUsersUrl)
                {
                    let otherUsers = []
                    data.forEach(x => {
                        let otherUsersUrl = new URL(x.pathname, window.location.origin);
                        let pathFound = otherUsersUrl.pathname.startsWith(ourUsersUrl.pathname);
                        if(!pathFound) return;
                        if(matchedUrlRule.query) {
                            let queryFound = Object.entries(matchedUrlRule.query).every(([key, val]) => {
                                if (!otherUsersUrl.searchParams.has(key)) {
                                    return false;
                                }
                                return ourUsersUrl.searchParams.get(key) === otherUsersUrl.searchParams.get(key);
                            });
                            if(!queryFound) return;
                        }
                        otherUsers.push(x);
                    });
                    return otherUsers;
                }

                const ourUrl = new URL(window.location.pathname + window.location.search, window.location.origin);

                let matchedUrlRule = checkIfOnUrl(ourUrl);
                if (matchedUrlRule) {
                    otherUsersHere = checkIfOthersMatchOurUrl(matchedUrlRule, ourUrl);
                }
            }
            catch(err){
                
            }
            thestore.dispatch(userActions.usersOnSamePage(otherUsersHere));

        });

        this.uiSocket.on("connect_error", (err) => {
            console.log("connect_error");
            newEvent({
                event: "connect_error"
            })
        })
        this.uiSocket.on("custom_connect_error", (err) => {
            console.log("connect_error");
            newEvent({
                event: "connect_error"
            })
        })
        this.uiSocket.on("disconnect", data => {
            console.log("disconnected_event");
            newEvent({
                event: "disconnected",
                data
            })
        })

    }

    emit(event, data) {
        if (this.uiSocket && this.uiSocket.connected) {
            this.uiSocket.emit(event, data)
        }
    }


    disconnect() {
        if (this.uiSocket && this.uiSocket.connected) {
            console.log("disconnecting ui sockets");
            this.uiSocket.disconnect();
            this.uiSocket.close()
        }
    }
}